module.exports = __webpack_public_path__ + "img/symbol_11.ce97daf6.png";